import enLang from './entries/en_US';
import frLang from './entries/fr_FR';
import trLang from './entries/tr_TR';
import esLang from './entries/es_ES';

const AppLocale = {
  en: enLang,
  fr: frLang,
  tr: trLang,
  es: esLang,
};

export default AppLocale;
